/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_E21Inputs */

const en__field_enum_e21 = /** @type {(inputs: _Field_Enum_E21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2`)
};

const de__field_enum_e21 = /** @type {(inputs: _Field_Enum_E21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2`)
};

/**
* | output |
* | --- |
* | "E2" |
*
* @param {_Field_Enum_E21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_e21 = /** @type {((inputs?: _Field_Enum_E21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_E21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_e21(inputs)
	return de__field_enum_e21(inputs)
});
export { _field_enum_e21 as "_field_enum_E2" }